import { render } from "./ContentSection.vue?vue&type=template&id=7948bb79&scoped=true"
import script from "./ContentSection.vue?vue&type=script&lang=js"
export * from "./ContentSection.vue?vue&type=script&lang=js"

import "./ContentSection.vue?vue&type=style&index=0&id=7948bb79&lang=scss&scoped=true"

import exportComponent from "/home/controlcenter/sourcecode/dubiverse/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7948bb79"]])

export default __exports__